import React, { useEffect, useState } from 'react';
import '../assets/css/material-dashboard.css'
import './criarordemmodal.css'
import HomeLf from './HomeLf';
import { db, firebaseAuth } from '../utils/firebase-config';
import { onAuthStateChanged } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { collection, doc, getDocs, updateDoc } from 'firebase/firestore';
import Background from 'three/examples/jsm/renderers/common/Background.js';
import { Center } from '@react-three/drei';
import {ExportToExcel} from './ExportToExcel'
import logo from '../assets/version2/logo.png'
import Rodape from './Rodape';

function RelatorioMain(params) {

  const navigate = useNavigate();


  const [current, setCurrent] = useState('');
  const [dataA, setDataA] = useState([]);
  const [filtrados, setFiltrados] = useState([]);
  const [filtradosB, setFiltradosB] = useState([]);
  const [objetoTarget, setObjetoTarget] = useState();
  const [dataId, setDataId] = useState();
const [criacao, setCriacao] = useState(10);
  const [nomeproj, setNomeproj] = useState('');
  const [objRelatorio, setObjRelatorio] = useState([]);
  const [objPendencias, setObjPendencias] = useState([]);

  const [dadosDaConta, setDadosDaConta] = useState([]);


  const [dataMaster, setDataMaster] = useState([]);


    const [mapeA, setMapeA] = useState([1]);
    const [hide, setHide] = useState('flex');

var count01 = 0;
const queryParameters = new URLSearchParams(window.location.search);
const parametroId = queryParameters.get("prjid");


const [countMp, setCountMp] = useState(1);

const [dataPendencias, setDataPendencias] = useState([]);














async function master(params) {

      

  var objMaster = [];
  var objMaster2 = [];

   


  onAuthStateChanged(firebaseAuth, async (currentUser) => {
    if (currentUser) {
      var usuarioLogado = currentUser.email;
      setCurrent(usuarioLogado);



      await fetch('https://apilumera.shop/api/consultaprojeto', {
        method: 'POST',
        body: JSON.stringify({
          id: parametroId,
    
        }),
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
      })
         .then((response) => response.json())
         .then((data) => {
    











        var criados2 = data;
        var tradd = [];

        tradd.push(criados2.ordens);
        setDataPendencias(criados2.ordens);

        tradd = tradd[0];
        console.log('SSSSSS ',tradd);
        var masterTrad = [];
      for (let i = 0; i < Object.keys(criados2.ordens).length; i++) {
            console.log(tradd[Object.keys(criados2.ordens)[i]]);
            masterTrad.push(tradd[Object.keys(criados2.ordens)[i]]);
      }
            var filtrar = [];
        for (let i = 0; i < masterTrad.length; i++) {
          if(masterTrad[i].status == 'Pendente'){
            filtrar.push(masterTrad[i]);
          }
          
        }
        setObjPendencias(filtrar);



























     console.log('DATAA ',data);
          setDataA(data);
          setObjRelatorio(data);
     
          setCriacao(new Date(data.dataDeCriacao._seconds*1000))
         })
         .catch((err) => {
            console.log(err.message);
         });
    




  fetch('https://apilumera.shop/api/consultausuario', {
    method: 'POST',
    body: JSON.stringify({

      email: usuarioLogado
   
    }),
    headers: {
      'Content-type': 'application/json; charset=UTF-8',
    },
  })
     .then((response) => response.json())
     .then((data) => {

 
      setDadosDaConta(data);
      console.log('Dados Usuários', data);
      
   
     })
     .catch((err) => {
        console.log(err.message);
     });







    };
  });






















        



}


async function editar(params) {
  navigate(`/editar?projeto=${params}`);
}





async function dell(params) {


  await updateDoc(doc(db, 'clientes', `${firebaseAuth.currentUser.email}:projetos`), {
    [params]: {
        nomeDoProjeto: 'nd',
      

    }
  
  });
  navigate(0);
}
















































































useEffect(()=> {
  master();
},[])











function enviarPost01() {


  function getObj(params) {

    for (let i = 0; i < dataMaster.length; i++) {
        if(dataMaster[i].split('###master')[3].replaceAll(' ', '') == params.replaceAll(' ', '')){
          return dataMaster[i];
        }
    }
}



var tradecolaboradores = [];
for (let i = 0; i < document.querySelectorAll('.colaboradores').length; i++) {
    tradecolaboradores.push(getObj(document.querySelectorAll('.colaboradores')[i].value.replaceAll(' ', '')))
  
}
  
  console.log('tradecolaboradores ',tradecolaboradores);

  var emailsColaboradores = [];

  for (let i = 0; i < tradecolaboradores.length; i++) {
    emailsColaboradores.push(tradecolaboradores[i].split('###master')[0]);
    
  }

  var nomeDaPendencia = document.querySelector('.inputNormal').value;
  var prioridadependencia = document.querySelector('.prioridade').value;



  fetch('https://apilumera.shop/api/criarordem', {
    method: 'POST',
    body: JSON.stringify({
      email: firebaseAuth.currentUser.email,
      parametroId: parametroId,
      nomeOrdem: nomeDaPendencia,
      participantes: tradecolaboradores,
      emailsParticipantes: emailsColaboradores,
      prioridade: prioridadependencia,
      nomeProjeto: nomeproj
    //  ordemPrioridade: ordemPrioridade
    }),
    headers: {
      'Content-type': 'application/json; charset=UTF-8',
    },
  })
     .then((response) => response.json())
     .then((data) => {
        navigate(-1);
     })
     .catch((err) => {
      navigate(-1);
     });



}


function setSearchNome(params) {
  let parlenght = params.length;
  console.log('LENGHT', parlenght, 'PARAMS', params);
  setFiltrados(dataA.filter(element => {
      if(params.length < 1){
        return dataA;
      } else {
        return element.nomeDoProjeto.toLowerCase().slice(0, parlenght) == params.toLowerCase().slice(0, parlenght);
      }


}))
}










function filtrarSelecao(param) {
  console.log(param)
var tradeobj = [];

for (let i = 0; i < dataA.length; i++) {
  if(dataA[i].nomeDoProjeto == param) {
    tradeobj.push(dataA[i]);
  }
}
    setFiltrados(tradeobj);
    console.log(tradeobj.nomeDoProjeto);

}













var trad = [];

function mapear() {
            
  setCountMp(countMp + 1);

  for (let i = 0; i < countMp; i++) {
      trad.push(i);
      
  }
  trad.push(countMp);
  setMapeA(trad);
}







    return (
        <div>


<HomeLf/>


















<div className="fixmargin"></div>









<div
  className="col-12"
  style={{
    display: "flex",
    flexFlow: "row nowrap",
    justifyContent: "center",
    marginTop: 50,
    paddingRight: 20
  }}
>

  <div className="col-9">
    <div>
      <div style={{ marginBottom: 40 }}>
        <h2 className="meusProjetos">Relatório</h2>
      </div>
      <div
        style={{ marginBottom: 50, marginLeft: "-30px" }}
        className="d-flex row wrap flex-row"
      >
 



     
      </div>
      












<div style={{ marginTop: 20 }}>
        {" "}
        {/* COL 12 SISTEM */}
        <div
          style={{
            border: "2px rgba(108, 98, 114, 0.45) solid",
            borderRadius: 12,
            padding: 18,
            
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              height: 40
            }}
          >
            <div
              style={{
                display: "flex",
                flexFlow: "row nowrap",
                justifyContent: "center",
                alignContent: "center",
            
                fontSize: 18
              }}
              className='meusProjetos'
            >
              {objRelatorio.nomeDoProjeto}
              <div
                className="red"
                style={{
                  height: 24,
                  backgroundColor: "#FEF6F1",
                  borderRadius: 14,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: 71,
                  paddingRight: 5,
                  marginLeft: 15,
                  backgroundColor: 'rgba(172, 109, 179, 0.24)',
                  color: "#AE530D"
                }}
              >
           
                <a style={{ paddingBottom: 2 }}> Projeto </a>
              </div>{" "}
            </div>
       
          </div>
      
          <div style={{padding: '20px'}}>
                    <div className='swithColor' style={{backgroundColor: "#F8F9FA", fontFamily: "Inter, serif",
                  fontSize: 14, fontWeight: "bold", marginTop: '5px'}}>Disciplinas: 
                  
                  <a style={{fontWeight: '400'}}>
                    {
                       objRelatorio.colaboradores != undefined && <>
                         {objRelatorio.colaboradores.map((data, index) => {
                        return <>{data.split('###master')[1]}, </>
                    })}
                       </> 
                    } </a>  
                      </div>   
                    <div className='swithColor' style={{backgroundColor: "white", fontFamily: "Inter, serif",
                  fontSize: 14, fontWeight: "bold", marginTop: '5px'}}>Colaboradores:  
    <a style={{fontWeight: '400'}}>
                    {
                       objRelatorio.colaboradores != undefined && <>
                         {objRelatorio.colaboradores.map((data, index) => {
                        return <>{data.split('###master')[3]}, </>
                    })}
                       </> 
                    } </a>  


                    </div>  
                     <div className='swithColor' style={{backgroundColor: "#F8F9FA", fontFamily: "Inter, serif",
                  fontSize: 14, fontWeight: "bold", marginTop: '5px'}}>Data de criação:  
                        {  objRelatorio.colaboradores != undefined && <a style={{fontWeight: '400'}}> {objRelatorio.dataDeCriacao.replace('GMT-0300 (Horário Padrão de Brasília)', '')} </a>}
                     </div>  
                
                     <div className='swithColor' style={{backgroundColor: "white", fontFamily: "Inter, serif",
                  fontSize: 14, fontWeight: "bold", marginTop: '5px'}}>Status: <a style={{fontWeight: '400'}}>{objRelatorio.andamento ? 'Em andamento' : 'Concluído'} </a>    </div>    

          </div>
       <ExportToExcel apiData={[objRelatorio]} fileName={objRelatorio.nomeDoProjeto} />
        </div>
      </div>



                        {objPendencias.map((data, index) => {
                            return <>
                            
                  <div style={{ marginTop: 20 }}>
        {" "}
        {/* COL 12 SISTEM */}
        <div
          style={{
            border: "1px #DEE1E6 solid",
            borderRadius: 12,
            padding: 18,
            
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              height: 40
            }}
          >
            <div
              style={{
                display: "flex",
                flexFlow: "row nowrap",
                justifyContent: "center",
                alignContent: "center",
            
                fontSize: 18
              }}
              className='meusProjetos'
            >
              {data.nome}
              <div
                className="red"
                style={{
                  height: 24,
                  backgroundColor: "#FEF6F1",
                  borderRadius: 14,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: 71,
                  paddingRight: 5,
                  marginLeft: 15,
                  color: "#AE530D"
                }}
              >
         
                <a style={{ paddingBottom: 2 }}> Pendência </a>
              </div>{" "}
            </div>
       
          </div>
      
          <div style={{padding: '20px'}}>
                    <div className='swithColor' style={{backgroundColor: "#F8F9FA", fontFamily: "Inter, serif",
                  fontSize: 14, fontWeight: "bold", marginTop: '5px'}}>Disciplinas: 
                  
                  <a style={{fontWeight: '400'}}>
                    {
                       data.participantes != undefined && <>
                         {data.participantes.map((data, index) => {
                        return <>{data.split('###master')[1]}, </>
                    })}
                       </> 
                    } </a>  
                      </div>   
                    <div className='swithColor' style={{backgroundColor: "white", fontFamily: "Inter, serif",
                  fontSize: 14, fontWeight: "bold", marginTop: '5px'}}>Colaboradores:  
    <a style={{fontWeight: '400'}}>
                    {
                       data.participantes != undefined && <>
                         {data.participantes.map((data, index) => {
                        return <>{data.split('###master')[3]}, </>
                    })}
                       </> 
                    } </a>  


                    </div>  
                     <div className='swithColor' style={{backgroundColor: "#F8F9FA", fontFamily: "Inter, serif",
                  fontSize: 14, fontWeight: "bold", marginTop: '5px'}}>Data de criação:  
                     <a style={{fontWeight: '400'}}> {data.dataDeCriacao.replace('GMT-0300 (Horário Padrão de Brasília)', '')}</a>  
                     </div>  
                
                     <div className='swithColor' style={{backgroundColor: "white", fontFamily: "Inter, serif",
                  fontSize: 14, fontWeight: "bold", marginTop: '5px'}}>Status: <a style={{fontWeight: '400'}}>Ativo</a>    </div>    

          </div>
           <ExportToExcel apiData={[data]} fileName={data.nome} />
        </div>
      </div>




























                            </>
                        })}


                               





















    </div>
  </div>
</div>




                        <Rodape/>


        </div>
    )
}
export default RelatorioMain;